<template>
  <div>
    <div class="fw-bold"><i class="fa-solid fa-bell me-2"/>配車依頼が入りました。</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'notice',
  mixins: [cf],
  data() {
    return {};
  },
  computed: {
    ...mapState(['notice', 'user']),
  },
  methods: {
    closeNotice() {
      const args = { name: '' };
      this.$store.dispatch('notice/setNotice', args, { root: true });
    },
  },
};
</script>

<style lang="scss" module="s">
.close {
  font-size: 12px;
  color: var(--label-secondary);
  border-bottom: 1px solid var(--label-secondary);
}
</style>
